export default "__VITE_ASSET__C80DsrRb__"